<template>
  <div class="aspect-ratio-container">
    <div class="aspect-ratio-content">
      <div class="aspect-ratio-header">
        <h2>比例选项管理</h2>
        <p>管理生成内容的比例选项，包括添加、编辑、删除比例</p>
      </div>
      
      <div class="aspect-ratio-actions">
        <el-button type="primary" @click="addRatio">添加比例</el-button>
      </div>

      <div class="aspect-ratio-table">
        <el-table :data="aspectRatios" style="width: 100%" v-loading="loading">
          <el-table-column prop="id" label="ID" width="80"></el-table-column>
          <el-table-column prop="ratio" label="比例值" width="120"></el-table-column>
          <el-table-column prop="name" label="比例名称"></el-table-column>
          <el-table-column prop="sort_order" label="排序" width="80"></el-table-column>
          <el-table-column prop="status" label="状态" width="80">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                @change="updateStatus(scope.row)"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="创建时间" width="180"></el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button size="small" type="primary" @click="editRatio(scope.row)">编辑</el-button>
              <el-button size="small" type="danger" @click="deleteRatio(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 添加/编辑比例对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="500px"
    >
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="比例值" prop="ratio">
          <el-input v-model="form.ratio" placeholder="请输入比例，如 1:1" :disabled="isEdit"></el-input>
          <div style="color: #909399; font-size: 12px; margin-top: 5px;">比例值用于代码中引用，创建后不能修改</div>
        </el-form-item>
        <el-form-item label="比例名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入比例名称，如 正方形"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort_order">
          <el-input-number v-model="form.sort_order" :min="0" :max="100" style="width: 100%"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'AspectRatioConfig',
  data() {
    return {
      loading: false,
      aspectRatios: [],
      dialogVisible: false,
      isEdit: false,
      editId: null,
      form: {
        ratio: '',
        name: '',
        sort_order: 0
      },
      rules: {
        ratio: [
          { required: true, message: '请输入比例值', trigger: 'blur' },
          { pattern: /^\d+:\d+$/, message: '比例格式应为数字:数字，如 1:1', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入比例名称', trigger: 'blur' }
        ],
        sort_order: [
          { required: true, message: '请输入排序', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    dialogTitle() {
      return this.isEdit ? '编辑比例' : '添加比例'
    }
  },
  mounted() {
    this.loadAspectRatios()
  },
  methods: {
    async loadAspectRatios() {
      this.loading = true
      try {
        const response = await axios.get('/api/admin/aspect-ratios')
        if (response.data.code === 200) {
          this.aspectRatios = response.data.aspect_ratios
        }
      } catch (error) {
        console.error('加载比例选项失败:', error)
        this.$message.error('加载比例选项失败')
      } finally {
        this.loading = false
      }
    },
    addRatio() {
      this.isEdit = false
      this.editId = null
      this.form = {
        ratio: '',
        name: '',
        sort_order: 0
      }
      this.dialogVisible = true
    },
    editRatio(row) {
      this.isEdit = true
      this.editId = row.id
      this.form = {
        ratio: row.ratio,
        name: row.name,
        sort_order: row.sort_order
      }
      this.dialogVisible = true
    },
    async submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            if (this.isEdit) {
              await axios.put(`/api/admin/aspect-ratios/${this.editId}`, this.form)
              this.$message.success('更新成功')
            } else {
              await axios.post('/api/admin/aspect-ratios', this.form)
              this.$message.success('创建成功')
            }
            this.dialogVisible = false
            this.loadAspectRatios()
          } catch (error) {
            console.error('提交失败:', error)
            const message = error.response?.data?.detail || '操作失败'
            this.$message.error(message)
          }
        }
      })
    },
    async updateStatus(row) {
      try {
        await axios.put(`/api/admin/aspect-ratios/${row.id}`, {
          status: row.status
        })
        this.$message.success('更新成功')
      } catch (error) {
        console.error('更新状态失败:', error)
        this.$message.error('更新状态失败')
        row.status = !row.status
      }
    },
    async deleteRatio(id) {
      this.$confirm('确定要删除该比例吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await axios.delete(`/api/admin/aspect-ratios/${id}`)
          this.$message.success('删除成功')
          this.loadAspectRatios()
        } catch (error) {
          console.error('删除失败:', error)
          this.$message.error('删除失败')
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.aspect-ratio-container {
  padding: 20px;
  background: #f5f7fa;
  min-height: 100vh;
}

.aspect-ratio-content {
  background: white;
  border-radius: 8px;
  padding: 30px;
}

.aspect-ratio-header {
  margin-bottom: 30px;
}

.aspect-ratio-header h2 {
  margin: 0 0 10px 0;
  color: #303133;
}

.aspect-ratio-header p {
  margin: 0;
  color: #909399;
  font-size: 14px;
}

.aspect-ratio-actions {
  margin-bottom: 20px;
}

.aspect-ratio-table {
  margin-top: 20px;
}
</style>
